import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  // form
  targetId: null,
  values: {},
}

const getters = {
	get: state => state,
}

const actions = {
	show ({commit}, targetId) {
		// cover
		this.dispatch('core/showModalCover')
		
		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
  },
  
  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
	showed (state) {
    Vue.set(state.values, 'inpDeviceSerial', null)
		state.active = true
	},
	hided (state) {
    state.active = false
	},

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // reset
  reset (state) {
    state.targetId = null
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
